module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-info"
  }, [(_vm.loading) ? _c('div', {
    attrs: {
      "id": "overlay"
    }
  }, [_c('div', {
    staticClass: "spinner"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Loading...")])]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "p-grid justify-content-end"
  }, [_c('div', {
    staticClass: "p-col"
  }, [_c('Button', {
    staticClass: "p-button p-component p-button-success addNewBtn btn-btm-0",
    attrs: {
      "icon": "pi pi-plus",
      "label": "NEW"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openBasic.apply(null, arguments)
      }
    }
  })], 1)]), _vm._v(" "), _c('Dialog', {
    style: ({
      width: '60vw'
    }),
    attrs: {
      "header": "Pay Head",
      "visible": _vm.displayBasic,
      "modal": true,
      "closable": false,
      "contentStyle": {
        'overflow': 'auto'
      }
    },
    on: {
      "update:visible": function($event) {
        _vm.displayBasic = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('div', {
          staticClass: "p-fluid p-formgrid p-grid"
        }, [_c('div', {
          staticClass: "p-field p-col-12 p-md-6"
        }, [_c('Button', {
          staticClass: "p-button-raised",
          attrs: {
            "label": !_vm.editing ? 'Add' : 'Update'
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.addPayHead.apply(null, arguments)
            }
          }
        }), _vm._v(" "), (!_vm.editing) ? _c('Button', {
          staticClass: "p-button-raised p-button-info",
          attrs: {
            "label": "Add & New"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.saveAndNewPayHead.apply(null, arguments)
            }
          }
        }) : _vm._e(), _vm._v(" "), _c('Button', {
          staticClass: "p-button-raised p-button-danger",
          attrs: {
            "label": "Cancel"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.cancel.apply(null, arguments)
            }
          }
        })], 1)])]
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', [_vm._v("Pay head"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "name"
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', [_vm._v("Account")]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "as": 'label::value',
      "options": _vm.accountMasterLists,
      "optionLabel": "name",
      "placeholder": "Select Account",
      "filter": true,
      "showClear": true,
      "id": "account"
    },
    model: {
      value: (_vm.accountId),
      callback: function($$v) {
        _vm.accountId = $$v
      },
      expression: "accountId"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-8"
  }, [_c('label', [_vm._v("Tax Policies")]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-12"
  }, [_c('Checkbox', {
    attrs: {
      "id": "includeInTaxation",
      "binary": true
    },
    model: {
      value: (_vm.includeInTaxation),
      callback: function($$v) {
        _vm.includeInTaxation = $$v
      },
      expression: "includeInTaxation"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "p-mr-2"
  }, [_vm._v("Include In Taxation")]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "id": "retirementFund",
      "binary": true
    },
    model: {
      value: (_vm.retirementFund),
      callback: function($$v) {
        _vm.retirementFund = $$v
      },
      expression: "retirementFund"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "p-mr-2"
  }, [_vm._v("Retirement Fund")]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "id": "lumpSum",
      "binary": true
    },
    model: {
      value: (_vm.lumpSum),
      callback: function($$v) {
        _vm.lumpSum = $$v
      },
      expression: "lumpSum"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "p-mr-2"
  }, [_vm._v("Lump Sum(Yearly)")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', [_vm._v("Marital Status")]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "id": "maritalStatus",
      "optionLabel": "name",
      "placeholder": "Select Marital Status",
      "options": _vm.maritalStatusList
    },
    model: {
      value: (_vm.maritalStatus),
      callback: function($$v) {
        _vm.maritalStatus = $$v
      },
      expression: "maritalStatus"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-8"
  }, [_c('label', [_vm._v("Tax Deduction Policies")]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-12"
  }, [_c('Checkbox', {
    attrs: {
      "id": "taxExempt",
      "binary": true
    },
    model: {
      value: (_vm.donated),
      callback: function($$v) {
        _vm.donated = $$v
      },
      expression: "donated"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "p-mr-2"
  }, [_vm._v("Donation To Tax Exempt Organization")]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "id": "lifeInsurance",
      "binary": true
    },
    model: {
      value: (_vm.hasLifeInsurance),
      callback: function($$v) {
        _vm.hasLifeInsurance = $$v
      },
      expression: "hasLifeInsurance"
    }
  }), _vm._v(" "), _c('label', [_vm._v("Life Insurance")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', [_vm._v("Compute On")]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "id": "computeOn",
      "optionLabel": "name",
      "placeholder": "Select PayHead",
      "options": _vm.payHeadDropdownList
    },
    model: {
      value: (_vm.computeOn),
      callback: function($$v) {
        _vm.computeOn = $$v
      },
      expression: "computeOn"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-8"
  }, [_c('label', [_vm._v("PayHead Type")]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-8"
  }, [_c('RadioButton', {
    attrs: {
      "id": "earningFromEmployee",
      "name": "Earning",
      "value": "Earning"
    },
    model: {
      value: (_vm.payHeadType),
      callback: function($$v) {
        _vm.payHeadType = $$v
      },
      expression: "payHeadType"
    }
  }), _vm._v(" "), _c('label', [_vm._v("Earning From Employee")]), _vm._v(" "), _c('RadioButton', {
    attrs: {
      "id": "deductionFromEmployee",
      "name": "Deduction",
      "value": "Deduction"
    },
    model: {
      value: (_vm.payHeadType),
      callback: function($$v) {
        _vm.payHeadType = $$v
      },
      expression: "payHeadType"
    }
  }), _vm._v(" "), _c('label', [_vm._v("Deduction From Employee")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', [_vm._v("Amount Type")]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "options": _vm.amountTypeList,
      "optionLabel": "key",
      "placeholder": "Select One"
    },
    model: {
      value: (_vm.amountType),
      callback: function($$v) {
        _vm.amountType = $$v
      },
      expression: "amountType"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', [_vm._v("Calculation Type")]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('Dropdown', {
    attrs: {
      "id": "calculationType",
      "optionLabel": "name",
      "options": _vm.calculationTypes
    },
    on: {
      "change": _vm.addHrPayHeadDerivedDTO
    },
    model: {
      value: (_vm.calculationType),
      callback: function($$v) {
        _vm.calculationType = $$v
      },
      expression: "calculationType"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', [_vm._v("Amount Predefined")]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('Checkbox', {
    attrs: {
      "id": "amountPredefined",
      "binary": true
    },
    model: {
      value: (_vm.amountPredefined),
      callback: function($$v) {
        _vm.amountPredefined = $$v
      },
      expression: "amountPredefined"
    }
  })], 1)]), _vm._v(" "), (_vm.calculationType.name === 'Derived') ? _c('div', {
    staticClass: "p-field p-col-12 p-md-12"
  }, [_c('DataTable', {
    staticClass: "p-datatable-responsive-demo p-datatable-gridlines editable-cells-table",
    attrs: {
      "value": _vm.hrPayheadDerivedConditionDTOList,
      "editMode": "cell"
    }
  }, [_c('Column', {
    attrs: {
      "header": "S.N",
      "field": ""
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [_vm._v("\n                  " + _vm._s(slotProps.index + 1) + "\n                ")]
      }
    }], null, false, 3694319558)
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Monthly Salary From",
      "field": "monthlyAmountFrom"
    },
    scopedSlots: _vm._u([{
      key: "editor",
      fn: function(slotProps) {
        return [_c('InputNumber', {
          attrs: {
            "id": "withoutgrouping",
            "mode": "decimal",
            "useGrouping": false
          },
          model: {
            value: (slotProps.data[slotProps.column.field]),
            callback: function($$v) {
              _vm.$set(slotProps.data, slotProps.column.field, $$v)
            },
            expression: "slotProps.data[slotProps.column.field]"
          }
        })]
      }
    }], null, false, 3143650525)
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Monthly Salary To",
      "field": "monthlyAmountTo"
    },
    scopedSlots: _vm._u([{
      key: "editor",
      fn: function(slotProps) {
        return [_c('InputNumber', {
          attrs: {
            "id": "withoutgrouping",
            "mode": "decimal",
            "useGrouping": false
          },
          model: {
            value: (slotProps.data[slotProps.column.field]),
            callback: function($$v) {
              _vm.$set(slotProps.data, slotProps.column.field, $$v)
            },
            expression: "slotProps.data[slotProps.column.field]"
          }
        })]
      }
    }], null, false, 3143650525)
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Amount Type",
      "field": "type"
    },
    scopedSlots: _vm._u([{
      key: "editor",
      fn: function(slotProps) {
        return [_c('Dropdown', {
          attrs: {
            "options": _vm.amountTypes,
            "optionLabel": "name",
            "optionValue": "value",
            "placeholder": "Select a type"
          },
          model: {
            value: (slotProps.data['type']),
            callback: function($$v) {
              _vm.$set(slotProps.data, 'type', $$v)
            },
            expression: "slotProps.data['type']"
          }
        })]
      }
    }], null, false, 2317796176)
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Value",
      "field": "value"
    },
    scopedSlots: _vm._u([{
      key: "editor",
      fn: function(slotProps) {
        return [(slotProps.data['type'] === 'Flat') ? _c('InputNumber', {
          attrs: {
            "id": "locale-user",
            "mode": "decimal",
            "minFractionDigits": 2
          },
          model: {
            value: (slotProps.data[slotProps.column.field]),
            callback: function($$v) {
              _vm.$set(slotProps.data, slotProps.column.field, $$v)
            },
            expression: "slotProps.data[slotProps.column.field]"
          }
        }) : _vm._e(), _vm._v(" "), (slotProps.data['type'] === 'Percentage') ? _c('InputNumber', {
          attrs: {
            "id": "locale-user",
            "mode": "decimal",
            "minFractionDigits": 2
          },
          model: {
            value: (slotProps.data[slotProps.column.field]),
            callback: function($$v) {
              _vm.$set(slotProps.data, slotProps.column.field, $$v)
            },
            expression: "slotProps.data[slotProps.column.field]"
          }
        }) : _vm._e()]
      }
    }], null, false, 3625911485)
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Action"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [_c('Button', {
          staticClass: "p-button-raised p-button-success",
          attrs: {
            "icon": "pi pi-plus"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.addHrPayHeadDerivedDTO.apply(null, arguments)
            }
          }
        }), _vm._v(" "), _c('Button', {
          staticClass: "p-button-danger",
          attrs: {
            "icon": "pi pi-times"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.removeHrPayHeadDerivedDTO(slotProps.index)
            }
          }
        })]
      }
    }], null, false, 2611275953)
  })], 1), _vm._v(" "), (_vm.calculationType.name === 'Derived') ? _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', [_vm._v("Compute On")]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "id": "computeOn",
      "optionLabel": "name",
      "placeholder": "Select PayHead",
      "options": _vm.payHeadDropdownList
    },
    model: {
      value: (_vm.computeOn),
      callback: function($$v) {
        _vm.computeOn = $$v
      },
      expression: "computeOn"
    }
  })], 1) : _vm._e()], 1) : _vm._e()])])], 1), _vm._v(" "), _c('DataTable', {
    staticClass: "p-datatable-responsive-demo p-datatable-gridlines",
    attrs: {
      "value": _vm.payHeadList,
      "paginator": true,
      "rows": 10,
      "filters": _vm.filters
    },
    scopedSlots: _vm._u([{
      key: "empty",
      fn: function() {
        return [_vm._v("No record found")]
      },
      proxy: true
    }])
  }, [_c('Column', {
    attrs: {
      "header": "S.N"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [_vm._v("\n          " + _vm._s(slotProps.index + 1) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Name",
      "sortable": true,
      "field": "name",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          model: {
            value: (_vm.filters['name']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'name', $$v)
            },
            expression: "filters['name']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Type",
      "sortable": true,
      "field": "payHeadType",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          model: {
            value: (_vm.filters['payHeadType']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'payHeadType', $$v)
            },
            expression: "filters['payHeadType']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Cal Type",
      "sortable": true,
      "field": "calculationType",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          model: {
            value: (_vm.filters['calculationType']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'calculationType', $$v)
            },
            expression: "filters['calculationType']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Marital Status",
      "sortable": true,
      "field": "maritalStatus",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          model: {
            value: (_vm.filters['maritalStatus']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'maritalStatus', $$v)
            },
            expression: "filters['maritalStatus']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Cr Account",
      "sortable": true,
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [_vm._v("\n          " + _vm._s(slotProps.data.account.name) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Action"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [_c('Button', {
          staticClass: "p-button-raised p-button-success",
          attrs: {
            "icon": "pi pi-pencil"
          },
          on: {
            "click": function($event) {
              return _vm.editPayHead(slotProps.data)
            }
          }
        }), _vm._v(" "), _c('Button', {
          staticClass: "p-button-raised p-button-danger",
          attrs: {
            "icon": "pi pi-trash"
          },
          on: {
            "click": function($event) {
              return _vm.openDeleteDialog(slotProps.data.id)
            }
          }
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('DeleteDialog', {
    on: {
      "cancel": _vm.cancelDelete,
      "deleted": _vm.deletePayHead
    },
    model: {
      value: (_vm.deleteDialog),
      callback: function($$v) {
        _vm.deleteDialog = $$v
      },
      expression: "deleteDialog"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f27ec0d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/HumanResource/Pay/payHead.vue
// module id = 2349
// module chunks = 0